<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-8">
          <div class="element-wrapper">
            <div class="element-box">
              <router-link
                style="font-size: 16px"
                :to="{ name: 'con-polizas-contables', params: {} }"
              >
                <i class="fas fa-chevron-left"></i> Regresar
              </router-link>
              <div v-if="!current.id">
                <h5 class="form-header" style="text-align: center">
                  Agregar Nueva Póliza Contable
                  <small><i class="fas fa-info-circle"></i></small>
                </h5>
              </div>
              <div class="st-meta float-right">
                <div class="element-actions">
                  <div class="btn-group">
                    <button
                      aria-expanded="false"
                      aria-haspopup="true"
                      class="btn btn-secondary dropdown-toggle"
                      data-toggle="dropdown"
                      type="button"
                      :hidden="!(current.id != null)"
                    >
                      <i class="fa fa-cogs"></i>
                      Acciones
                    </button>
                    <div class="dropdown-menu dropdown-menu-right">
                      <button
                        type="button"
                        class="dropdown-item"
                        :class="{ disabled: !(current.estado == 'B') }"
                        @click="abrir"
                        :disabled="!(current.estado == 'B')"
                        href="#"
                      >
                        <i class="fa fa-unlock"></i>
                        Abrir Operación
                      </button>
                      <button
                        class="dropdown-item"
                        @click="cerrar"
                        :disabled="!(current.estado == 'A')"
                        href="#"
                      >
                        <i class="fa fa-lock"></i>
                        Cerrar Operación
                      </button>
                      <button class="dropdown-item" @click="Imprimir" href="#">
                        <i class="fa fa-print"></i>
                        Imprimir Reporte
                      </button>
                      <button
                        class="dropdown-item"
                        @click="anular"
                        href="#"
                        :disabled="!(current.estado != '9')"
                      >
                        <i class="fa fa-archive"></i>
                        Anular Operación
                      </button>
                      <div class="dropdown-divider"></div>
                      <button
                        class="dropdown-item"
                        :disabled="current.conciliado == true"
                        href="#"
                      >
                        <i class="fas fa-coins"></i>
                        Aplicar Conciliación
                      </button>
                      <div class="dropdown-divider"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                &nbsp;&nbsp;&nbsp;
                <h3 class="form-header" v-if="current.id">
                  Póliza Contable
                  <span># {{ current.numero }}</span>
                </h3>
              </div>
              <div class="form-buttons-w">
                <div
                  class="form-group"
                  v-if="current.estado == 'A' && current.id != null"
                >
                  <button
                    :hidden="!(current.estado == 'A' && current.id != null)"
                    type="button"
                    class="btn btn-md btn-info"
                    @click="showModalCargo()"
                  >
                    <i class="fa fa-plus"></i> Agregar Línea Detalle
                  </button>
                  <button
                    class="btn btn-primary"
                    @click="guardar()"
                    :hidden="!(current.estado == 'A')"
                  >
                    <i class="fas fa-check"></i> Guardar Cambios
                  </button>
                </div>
                <div class="row">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <h6 class="form-header text-success">Detalle de póliza</h6>
                </div>
              </div>
              <br />
              <div class="invoice-table">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th class="text-center">Centro Costo</th>
                      <th class="text-center">Cuenta Contable</th>
                      <th class="text-center">Descripción</th>
                      <th class="text-center">Cargo (Q)</th>
                      <th class="text-right">Abono (Q)</th>
                      <th class="text-center" v-if="current.estado == 'A'">Opciones</th>
                      <th class="text-center" v-if="current.estado != 'A'">Opciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="detalle in current.polizad_set"
                      v-bind:key="detalle.id"
                      :class="{
                        abonando: detalle.abono != 0,
                        cargando: detalle.cargo != 0,
                      }"
                    >
                      <td style="width: 40px">
                        {{ detalle.centro_costo }}
                      </td>
                      <td class="text-left">
                        {{ detalle.cuenta_contable_obj.id }}
                        <span> - </span>
                        {{ detalle.cuenta_contable_obj.nombre }}
                      </td>
                      <td class="text-left">
                        {{ detalle.descripcion }}
                      </td>
                      <td class="text-right" style="width: 90px">
                        <span v-if="parseInt(detalle.cargo) > 0"
                          >Q. {{ detalle.cargo }}</span
                        >
                      </td>
                      <td class="text-right" style="width: 90px">
                        <span v-if="parseInt(detalle.abono) > 0"
                          >Q. {{ detalle.abono }}</span
                        >
                      </td>
                      <td class="text-center" style="width: 100px">
                        <div class="dropdown" v-if="current.estado == 'A'">
                          <div class="dropdown-content">
                            <button
                              id="dpdbuttons"
                              type="button"
                              class="btn btn-sm mr-0 btn-light"
                              data-toggle="modal"
                              :disabled="!(current.estado == 'A')"
                              data-mini="true"
                              @click="editarLinea(detalle)"
                              title="Modificar Línea"
                            >
                              <i class="fa fa-edit"></i>
                            </button>
                            <button
                              id="dpdbuttons"
                              class="btn btn-sm mr-0 btn-light"
                              :disabled="!(current.estado == 'A')"
                              @click="eliminarLinea(detalle)"
                              data-mini=" true"
                              title="Eliminar Detalle"
                            >
                              <i class="fa fa-trash"></i>
                            </button>
                          </div>
                        </div>
                        <div class="dropdown" v-if="current.estado != 'A'">
                          <i
                            class="fa fa-lock"
                            style="font-size: 0.7em"
                            title="La Operación debe estar abierta para ver las Opciones"
                          ></i>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="3">
                        <font size="3">Totales:</font>
                      </td>
                      <td
                        class="text-right"
                        colspan="1"
                        v-bind:class="{
                          'text-danger': current.total_abonos != current.total_cargos,
                        }"
                      >
                        <font size="2"> Q. {{ current.total_cargos }}</font>
                      </td>
                      <td
                        class="text-right"
                        colspan="1"
                        v-bind:class="{
                          'text-danger': current.total_abonos != current.total_cargos,
                        }"
                      >
                        <font size="2">Q. {{ current.total_abonos }}</font>
                      </td>
                      <td class="text-right">
                        <i
                          v-if="current.total_abonos == current.total_cargos"
                          class="fas fa-check fa-lg text-success"
                          title="Póliza Cuadrada"
                          style="font-size: 0.8em"
                        ></i>
                        <i
                          v-if="current.total_abonos != current.total_cargos"
                          class="fa fa-exclamation-triangle fa-lg"
                          title="Póliza Descuadrada"
                          style="font-size: 0.8em"
                        ></i>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-4 panel panel-hover"
          style="position: fixed; right: 1vw; width: 26vw"
        >
          <h4>Datos de Póliza</h4>
          <div
            class="badge"
            :class="{
              'badge-success': current.estado == 'A',
              'badge-warning': current.estado == 'B',
              'badge-danger': current.estado == '9',
            }"
          >
            <i class="os-icon os-icon-ui-09"></i>
            <span v-if="current.estado_str">{{ current.estado_str }}</span>
            <span v-if="current.id && !current.estado_str">En Proceso</span>
          </div>
          &nbsp;
          <div
            class="badge badge-danger"
            v-if="current.total_abonos != current.total_cargos"
          >
            <span><i class="os-icon os-icon-wallet-loaded"></i> Póliza Descuadrada</span>
          </div>
          <hr />
          <div class="col-12">
            <label
              v-bind:class="{
                'text-danger': errors && errors.fecha,
              }"
              >Fecha</label
            >
            <input
              type="date"
              class="form-control"
              v-model="current.fecha_"
              :disabled="current.estado != 'A'"
            />
            <small v-if="errors && errors.fecha" class="form-text text-danger">{{
              errors.fecha[0]
            }}</small>
          </div>
          <div class="col-12">
            <label
              v-bind:class="{
                'text-danger': errors && errors.tipo_poliza,
              }"
              >Tipo de Póliza</label
            >
            <select
              class="form-control"
              autofocus="autofocus"
              :disabled="!(current.estado == 'A')"
              v-model="current.tipo_poliza"
            >
              <option v-for="(c, key) in tipos_polizas" :value="c.id" :key="key">
                {{ c.nombre }}
              </option>
            </select>
            <small v-if="errors && errors.tipo_poliza" class="form-text text-danger">{{
              errors.tipo_poliza[0]
            }}</small>
          </div>
          <div class="col-12">
            <label
              v-bind:class="{
                'text-danger': errors && errors.docto_ref,
              }"
              >Docto. Referencia</label
            >
            <input
              v-model="current.docto_ref"
              autofocus="autofocus"
              :disabled="!(current.estado == 'A')"
              class="form-control"
              placeholder="Referencia"
              type="text"
              v-bind:class="{
                'is-invalid': errors && errors.docto_ref,
              }"
            />
            <small v-if="errors && errors.docto_ref" class="form-text text-danger">{{
              errors.docto_ref[0]
            }}</small>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-6">
                <label
                  v-bind:class="{
                    'text-danger': errors && errors.total_cargos,
                  }"
                  >Monto en Cargo</label
                >
                <div class="input-group input-group-md">
                  <div class="input-group-prepend">
                    <div style="background-color: #9ad473" class="input-group-text">
                      Q
                    </div>
                  </div>
                  <input
                    disabled="disabled"
                    v-model="current.total_cargos"
                    class="form-control"
                    placeholder="Cargo"
                    v-bind:class="{
                      'is-invalid': errors && errors.total_cargos,
                    }"
                    style="text-align: right"
                    type="text"
                  />
                  <small
                    v-if="errors && errors.total_cargos"
                    class="form-text text-danger"
                    >{{ errors.total_cargos[0] }}</small
                  >
                </div>
              </div>
              <div class="form-group col-6">
                <label
                  v-bind:class="{
                    'text-danger': errors && errors.total_abonos,
                  }"
                  >Monto en Abono</label
                >
                <div class="input-group input-group-md">
                  <div class="input-group-prepend">
                    <div style="background-color: #9ad473" class="input-group-text">
                      Q
                    </div>
                  </div>
                  <input
                    disabled="disabled"
                    v-model="current.total_abonos"
                    class="form-control"
                    placeholder="Abono"
                    v-bind:class="{
                      'is-invalid': errors && errors.total_abonos,
                    }"
                    style="text-align: right"
                    type="text"
                  />
                  <small
                    v-if="errors && errors.total_abonos"
                    class="form-text text-danger"
                    >{{ errors.total_abonos[0] }}</small
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="form-group col-12">
            <label
              v-bind:class="{
                'text-danger': errors && errors.descripcion,
              }"
              >Descripción</label
            >
            <textarea
              v-model="current.descripcion"
              autofocus="autofocus"
              :disabled="!(current.estado == 'A')"
              class="form-control"
              placeholder="Descripción"
              type="text"
              rows="3"
              v-bind:class="{
                'is-invalid': errors && errors.descripcion,
              }"
            ></textarea>
            <small v-if="errors && errors.descripcion" class="form-text text-danger">{{
              errors.descripcion[0]
            }}</small>
          </div>
          <div class="col-12" style="text-align: right">
            <button
              class="btn btn-dark"
              @click="guardar()"
              :hidden="!(current.id == null)"
            >
              <i class="fas fa-save"></i> Guardar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal Agregar Detalle-->
    <div
      aria-hidden="true"
      class="modal modal fade"
      id="modalAgregarDetalle"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header faded" style="background-color: #dddeff">
            <h5 class="modal-title">Agregar Detalle</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <CuentaContableSelectComponent class="col-12" :current="current_detalle" />
              <div class="col-6">
                <label
                  v-bind:class="{
                    'text-danger':
                      current_detalle.errors && current_detalle.errors.centro_costo,
                  }"
                  >Centro Costo</label
                >
                <select
                  class="form-control"
                  autofocus="autofocus"
                  v-model="current_detalle.centro_costo"
                >
                  <option v-for="(c, key) in centrocosto" :value="c.id" :key="key">
                    {{ c.nombre }}
                  </option>
                </select>
                <small
                  v-if="current_detalle.errors && current_detalle.errors.centro_costo"
                  class="form-text text-danger"
                  >{{ current_detalle.errors.centro_costo[0] }}</small
                >
              </div>
              <div class="col-6">
                <label
                  v-bind:class="{
                    'text-danger':
                      current_detalle.errors && current_detalle.errors.descripcion,
                  }"
                  >Descripción</label
                >
                <textarea
                  v-model="current_detalle.descripcion"
                  autofocus="autofocus"
                  class="form-control"
                  placeholder="Descripción"
                  type="text"
                  v-bind:class="{
                    'is-invalid':
                      current_detalle.errors && current_detalle.errors.descripcion,
                  }"
                ></textarea>
                <small
                  v-if="current_detalle.errors && current_detalle.errors.descripcion"
                  class="form-text text-danger"
                  >{{ current_detalle.errors.descripcion[0] }}</small
                >
              </div>
              <div class="col-6">
                <div class="form-group">
                  <label
                    v-bind:class="{
                      'text-danger':
                        current_detalle.errors && current_detalle.errors.cargo,
                    }"
                    >Cargo</label
                  >
                  <input
                    v-model="current_detalle.cargo"
                    class="form-control"
                    placeholder="Cargo"
                    type="number"
                    style="text-align: center; font-size: 125%"
                    v-bind:class="{
                      'is-invalid':
                        current_detalle.errors && current_detalle.errors.cargo,
                    }"
                  />
                  <small
                    v-if="current_detalle.errors && current_detalle.errors.cargo"
                    class="form-text text-danger"
                    >{{ current_detalle.errors.cargo[0] }}</small
                  >
                </div>
              </div>
              <div class="col-6">
                <label
                  v-bind:class="{
                    'text-danger': current_detalle.errors && current_detalle.errors.abono,
                  }"
                  >Abono</label
                >
                <input
                  v-model="current_detalle.abono"
                  class="form-control"
                  placeholder="Abono"
                  type="number"
                  style="text-align: center; font-size: 125%"
                  v-bind:class="{
                    'is-invalid': current_detalle.errors && current_detalle.errors.abono,
                  }"
                />
                <small
                  v-if="current_detalle.errors && current_detalle.errors.abono"
                  class="form-text text-danger"
                  >{{ current_detalle.errors.abono[0] }}</small
                >
              </div>
            </div>
          </div>
          <div class="modal-footer" id="addmodalfooter">
            <button class="btn btn-primary" @click="agregarDetalle" type="button">
              Agregar
            </button>
            <button
              class="btn btn-secondary"
              ref="cerrarModal"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal Editar Línea -->
    <div
      class="modal fade"
      id="editarLinea"
      tabindex="-1"
      role="dialog"
      aria-labelledby="editarLineaModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header" style="background-color: #dddeff">
            <h5 class="modal-title" id="EditarLineaModal">Editar Detalle</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <CuentaContableSelectComponent :current="current_detalle" />
              </div>
              <div class="col-4">
                <label
                  v-bind:class="{
                    'text-danger':
                      current_detalle.errors && current_detalle.errors.centro_costo,
                  }"
                  >Centro Costo</label
                >
                <select
                  class="form-control"
                  autofocus="autofocus"
                  v-model="current_detalle.centro_costo"
                >
                  <option v-for="(c, key) in centrocosto" :value="c.id" :key="key">
                    {{ c.nombre }}
                  </option>
                </select>
                <small
                  v-if="current_detalle.errors && current_detalle.errors.centro_costo"
                  class="form-text text-danger"
                  >{{ current_detalle.errors.centro_costo[0] }}</small
                >
              </div>
              <div class="col-8">
                <label
                  v-bind:class="{
                    'text-danger':
                      current_detalle.errors && current_detalle.errors.descripcion,
                  }"
                  >Descripción</label
                >
                <textarea
                  v-model="current_detalle.descripcion"
                  autofocus="autofocus"
                  class="form-control"
                  placeholder="Descripción"
                  type="text"
                  v-bind:class="{
                    'is-invalid':
                      current_detalle.errors && current_detalle.errors.descripcion,
                  }"
                ></textarea>
                <small
                  v-if="current_detalle.errors && current_detalle.errors.descripcion"
                  class="form-text text-danger"
                  >{{ current_detalle.errors.descripcion[0] }}</small
                >
              </div>
              <div class="col-6">
                <label
                  v-bind:class="{
                    'text-danger': current_detalle.errors && current_detalle.errors.cargo,
                  }"
                  >Cargo</label
                >
                <input
                  v-model="current_detalle.cargo"
                  class="form-control"
                  placeholder="Cargo"
                  type="number"
                  style="text-align: center; font-size: 125%"
                  v-bind:class="{
                    'is-invalid': current_detalle.errors && current_detalle.errors.cargo,
                  }"
                />
                <small
                  v-if="current_detalle.errors && current_detalle.errors.cargo"
                  class="form-text text-danger"
                  >{{ current_detalle.errors.cargo[0] }}</small
                >
              </div>
              <div class="col-6">
                <label
                  v-bind:class="{
                    'text-danger': current_detalle.errors && current_detalle.errors.abono,
                  }"
                  >Abono</label
                >
                <input
                  v-model="current_detalle.abono"
                  class="form-control"
                  placeholder="Abono"
                  type="number"
                  style="text-align: center; font-size: 125%"
                  v-bind:class="{
                    'is-invalid': current_detalle.errors && current_detalle.errors.abono,
                  }"
                />
                <small
                  v-if="current_detalle.errors && current_detalle.errors.abono"
                  class="form-text text-danger"
                  >{{ current_detalle.errors.abono[0] }}</small
                >
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" @click="EditarDetalle()" type="button">
              Modificar Linea <i class="fas fa-edit"></i>
            </button>
            <button
              class="btn btn-danger"
              ref="cerrarModal"
              data-dismiss="modal"
              type="button"
            >
              Cancelar X
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import PolizasContablesServices from "@/services/conta/PolizasContablesServices";
import Notifications from "@/notifications/notifications";
import CuentaContableSelectComponent from "@/components/commons/CuentaContableSelectComponent";
import DynamicService from "@/services/commons/DynamicService";

export default {
  data() {
    return {
      current: {
        fecha: "",
        fecha_: "",
        estado: "A",
        tipo_poliza_obj: {
          id: null,
        },
      },
      errors: [],
      current_detalle: {
        id: null,
        cuenta_contable: "",
      },
    };
  },

  components: {
    CuentaContableSelectComponent,
  },

  computed: {
    ...mapGetters({
      tipos_polizas: "conta/tipos_polizas",
      cuentas: "catalogos/cuentas",
      centrocosto: "catalogos/centro_costo",
    }),
  },
  mounted() {
    let self = this;
    if (self.$route.params.id) {
      self.refreshCurrent();
    }
    self.refreshTipoPoliza();
    self.refreshCentroCosto();
  },

  methods: {
    refreshCurrent() {
      let self = this;
      PolizasContablesServices.getById(this.$route.params.id).then((response) => {
        self.current = response.data;
        self.current.tienda = response.data.tienda;
        self.current.cuenta_contable = self.current.cuenta_contable;
        self.current.estado_str = self.current.estado_str;
        self.current.tipo_poliza = self.current.tipo_poliza;
        self.current.fecha_ = moment(self.current.fecha, "DD/MM/YYYY").format(
          "YYYY-MM-DD"
        );
      });
    },
    refreshCentroCosto() {
      let self = this;
      self.$store.dispatch("catalogos/centro_costo", {
        activa: true,
        quitar_paginacion: true,
      });
    },
    refreshTipoPoliza() {
      let self = this;
      self.$store.dispatch("conta/tipos_polizas", {
        activa: true,
        quitar_paginacion: true,
      });
    },
    showModalCargo() {
      let self = this;
      $("#modalAgregarDetalle").modal();
    },
    cleanErrorDetalle() {
      let self = this;
      self.current_detalle = {
        id: null,
        errors: [],
      };
      self.errors = [];
    },
    EditarDetalle() {
      let self = this;
      let det = Object.assign({}, self.current_detalle);
      if (det.cargo == null || det.cargo == "") {
        det.cargo = 0;
      }
      if (det.abono == null || det.abono == "") {
        det.abono = 0;
      }
      if (!det.cuenta_contable) {
        Notifications.alert.error("Error", "Cuenta contable es Requerida");
      }
      det.cuenta_contable = det.cuenta_contable.id;
      det.centro_costo_id = det.centro_costo;
      DynamicService.postAction(
        "conta",
        "poliza",
        self.current.id,
        "modificar_detalle",
        det
      )
        .then((response) => {
          Notifications.alert.success("Listo", "Linea Modificada");
          $("#editarLinea").modal("hide");
          self.refreshCurrent();
          self.$refs.cerrarModal.click();
          self.cleanErrorDetalle();
        })
        .catch((error) => {
          self.current_detalle.errors = error.response.data;
          if (error.response.data && error.response.data.detail) {
            Notifications.alert.error("Agregar Linea", error.response.data.detail);
          }
        });
    },
    agregarDetalle() {
      let self = this;
      let det = Object.assign({}, self.current_detalle);
      if (det.cargo == null || det.cargo == "") {
        det.cargo = 0;
      }
      if (det.abono == null || det.abono == "") {
        det.abono = 0;
      }
      if (!det.cuenta_contable) {
        Notifications.alert.error("Error", "Cuenta contable es Requerida");
      }
      det.cuenta_contable = det.cuenta_contable.id;
      det.centro_costo_id = det.centro_costo;
      PolizasContablesServices.agregar_detalle(self.current.id, det)
        .then((response) => {
          Notifications.alert.success("Listo", "Linea agregada");
          $("#modalAgregarDetalle").modal("hide");
          self.refreshCurrent();
          self.$refs.cerrarModal.click();
          self.cleanErrorDetalle();
        })
        .catch((error) => {
          self.current_detalle.errors = error.response.data;
          if (error.response.data && error.response.data.detail) {
            Notifications.alert.error("Agregar Linea", error.response.data.detail);
          }
        });
    },
    guardar() {
      let self = this;
      if (self.current.fecha_) {
        self.current.fecha = moment(self.current.fecha_).format("DD/MM/YYYY");
      }
      PolizasContablesServices.save(self.current)
        .then((res) => {
          Notifications.alert.success(
            "Póliza contable",
            "Se ha guardado la Información."
          );
          if (!this.$route.params.id) {
            self.$router.push({
              name: "con-polizas-contables-editar",
              params: { id: res.data.id },
            });
          }
          self.refreshCurrent();
          self.cleanErrorDetalle();
        })
        .catch((error) => {
          self.errors = error.response.data;
          console.log(self.errors);
        });
    },
    abrir() {
      let self = this;
      Notifications.alert.confirm(
        "Polizas Contables",
        "Desea Abrir la transacción?",
        "Si Abrir",
        function () {
          PolizasContablesServices.abrir(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Polizas Contables",
                "Transaccion abierta puede continuar editando."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error("Abrir Transaccion", error.response.data.detail);
            });
        }
      );
    },
    cerrar() {
      let self = this;
      Notifications.alert.confirm(
        "Polizas Contables",
        "Desea cerrar la transacción?",
        "Si Abrir",
        function () {
          PolizasContablesServices.cerrar(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Polizas Contables",
                "Se ha cerrado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error("Cerrar Transaccion", error.response.data.detail);
            });
        }
      );
    },
    Imprimir() {
      let op;
      op = this.$route.params.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=conta/poliza_contable.jrxml&id=${op}`
      );
    },
    anular() {
      let self = this;
      Notifications.alert.confirm(
        "Polizas Contables",
        "Desea Anular la transacción?",
        "Si Anular",
        function () {
          PolizasContablesServices.anular(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Polizas Contables",
                "Se ha anulado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error("Anular Transaccion", error.response.data.detail);
            });
        }
      );
    },
    eliminarLinea(detalle) {
      let self = this;
      Notifications.alert.confirm(
        "Eliminar detalle",
        "¿Esta seguro(a)?",
        "",
        function () {
          PolizasContablesServices.eliminar_detalle(self.current.id, {
            id: detalle.id,
          })
            .then((response) => {
              Notifications.alert.success("Listo", "Se ha Agregado la Conciliacion.");
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error("Eliminar Linea", error.response.data.detail);
            });
        }
      );
    },
    editarLinea(detalle) {
      let self = this;
      self.current_detalle = detalle;
      DynamicService.getById(
        "conta",
        "cuenta-contable",
        detalle.cuenta_contable_obj.id
      ).then((response) => {
        self.current_detalle.cuenta_contable = response.data;
      });
      $("#editarLinea").modal("show");
    },
    onChangeCuentaContable(event) {
      // this.$emit("onChangeCuentaContable", event);
      console.log(event);
      // this.current_detalle.cuenta_contable = event;
    },
    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },
    search: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      vm.$store.dispatch("conta/cuenta_contable", {
        page: 1,
        activo: true,
        quitar_paginacion: true,
        "filter[search]": search,
      });
      loading(false);
    }, 350),
  },
};
</script>
